import { syncURLParams } from "./searchHelpers";
import currencyRanges from "./currencyRanges.json";

export const applyFilterURL = (state) => {
  const searchParams = new URLSearchParams(window.location.search);
  if (state.filters.budgets) {
    const currentBudgets = state.filters.budgets.split(",");
    const rangeInSelectedCurrency =
      currencyRanges[state.currency.code].yacht.filterRange;

    const results = [];
    currentBudgets.forEach((_b) => {
      results.push(rangeInSelectedCurrency[_b][0]);
    });

    searchParams.set("budgets", results.join(","));
  } else {
    searchParams.delete("budgets");
  }

  if (state.filters.destinations) {
    searchParams.set("destinations", state.filters.destinations);
  } else {
    searchParams.delete("destinations");
  }

  if (state.filters.yachtCapacities) {
    searchParams.set("yachtCapacities", state.filters.yachtCapacities);
  } else {
    searchParams.delete("yachtCapacities");
  }

  if (state.filters.yachtSizes) {
    searchParams.set("yachtSizes", state.filters.yachtSizes);
  } else {
    searchParams.delete("yachtSizes");
  }

  if (state.filters.facilities) {
    searchParams.set("facilities", state.filters.facilities);
  } else {
    searchParams.delete("facilities");
  }

  syncURLParams(searchParams);
};

export const getCountryFilters = () => {
  return `__platform_country_id:${window.zubluDestination.id}`;
};

export const getBudgetFilters = (filters) => {
  const filteringBudgets = filters.budgets.split(",").filter((x) => x);

  const selectedCurrency = window.topNavStore.state.currency;
  const rangeInSelectedCurrency =
    currencyRanges[selectedCurrency.code].yacht.filterRange;
  const rate = window.zubluCurrencyTable[selectedCurrency.code];

  if (filteringBudgets.length === 0) {
    return "__odyssey_price_per_night > 0";
  }

  let numericFilters = [];

  if (filteringBudgets.includes("0")) {
    numericFilters.push(
      `__odyssey_price_per_night:${rangeInSelectedCurrency[0][0] *
        rate} TO ${rangeInSelectedCurrency[0][1] * rate}`
    );
  }
  if (filteringBudgets.includes("1000")) {
    numericFilters.push(
      `__odyssey_price_per_night:${rangeInSelectedCurrency[1000][0] *
        rate} TO ${rangeInSelectedCurrency[1000][1] * rate}`
    );
  }
  if (filteringBudgets.includes("2000")) {
    numericFilters.push(
      `__odyssey_price_per_night:${rangeInSelectedCurrency[2000][0] *
        rate} TO ${rangeInSelectedCurrency[2000][1] * rate}`
    );
  }
  if (filteringBudgets.includes("4000")) {
    numericFilters.push(
      `__odyssey_price_per_night > ${rangeInSelectedCurrency[4000][0] * rate}`
    );
  }

  return numericFilters;
};

export const getYachtSizeFilters = (filters) => {
  const filteringYachtSizes = filters.yachtSizes.split(",").filter((x) => x);

  if (filteringYachtSizes.length === 0) {
    return "__odyssey_vessel_length > 0";
  }

  let numericFilters = [];

  if (filteringYachtSizes.includes("0")) {
    numericFilters.push("__odyssey_vessel_length:0 TO 29");
  }
  if (filteringYachtSizes.includes("30")) {
    numericFilters.push("__odyssey_vessel_length:30 TO 39");
  }
  if (filteringYachtSizes.includes("40")) {
    numericFilters.push("__odyssey_vessel_length:40 TO 49");
  }
  if (filteringYachtSizes.includes("50")) {
    numericFilters.push("__odyssey_vessel_length > 50");
  }

  return numericFilters;
};

export const getYachtCapacityFilters = (filters) => {
  const filteringYachtCapacities = filters.yachtCapacities
    .split(",")
    .filter((x) => x);

  if (filteringYachtCapacities.length === 0) {
    return "__odyssey_max_occupancy > 0";
  }

  let numericFilters = [];

  if (filteringYachtCapacities.includes("0")) {
    numericFilters.push("__odyssey_max_occupancy:0 TO 2");
  }
  if (filteringYachtCapacities.includes("3")) {
    numericFilters.push("__odyssey_max_occupancy:3 TO 4");
  }
  if (filteringYachtCapacities.includes("5")) {
    numericFilters.push("__odyssey_max_occupancy:5 TO 6");
  }
  if (filteringYachtCapacities.includes("7")) {
    numericFilters.push("__odyssey_max_occupancy:7 TO 8");
  }
  if (filteringYachtCapacities.includes("9")) {
    numericFilters.push("__odyssey_max_occupancy > 9");
  }

  return numericFilters;
};
